export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/hotel/front/search',
      name: 'distributor-hotel-front-search',
      meta: {
        footer_margin_none: true,
      },
      component: () => import('@/page/distributor/hotel/front/hotel-search/1.0.1/index.vue'),
    },
  ]
};
